import React from "react";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "../ManagerDashboard/Common/Graph/ZenVerBarChart";
import ZenClusterColumnVer from "../ManagerDashboard/Common/Graph/ZenClusterColVer";
import ZenVerStackBar from"../ManagerDashboard/Common/Graph/ZenVerStackBar";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";

class SbLineDoh extends React.Component {
  state = {
    ZenClusterColumnVer: null,
    ZenVerStackBar:null,
    ZenVerBarChart:null,
    loading: true,
    loginError: false,
    // lid: "all",
    // selectedMnt: "all",
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.fetchTrendData()
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab) => {
    liracrypt
    // .get("/sb/dashboard/chartdata", {
    //   lid,
    //   mnt,
    //   typ: "line_rog",
    //   subTyp: selectedTab,
      
    // })
      .get("/sb/dashboard/chartdata", this.props.urlData || {})
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenVerStackBar"] = resp["data"]["line_rog_status"];
        respData["ZenClusterColumnVer"] = resp["data"]["line_3_day_doh"];
        respData["ZenVerBarChart"] = resp["data"]["line_part_wise_doh"];
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <div>

<Row style={{   background: "#000000"}} >
            <Col span={10}>
            <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 0px 0px 10px",
                height: "450px",
              
              }}
            >
             <ZenVerStackBar
                divId={"ZenVerStackBar01"}
                data={this.state.ZenVerStackBar.data}
                config={this.state.ZenVerStackBar.config}
                onChange={(data) => this.changeBasicGraph(data)}
              />
            </div>
            </Col>
            <Col span={10}>
            <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 0px 0px 20px",
                height: "450px",
              }}
            >
              <ZenClusterColumnVer
                divId={"chartdiv"}
                // respData = {this.state.ZenVerBarChart}
                data={this.state.ZenClusterColumnVer.data}
                config={this.state.ZenClusterColumnVer.config}
                onChange={(data) => this.changeBasicGraph(data)}
              />
            </div>

            <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            marginTop: "10px",
                            width: "50%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart1"}
                            // respData = {this.state.ZenVerBarChart}
                            data={this.state.ZenVerBarChart.data}
                            config={this.state.ZenVerBarChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>








            </Col>
           
            
 
           
          </Row>


        </div>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default SbLineDoh;